import { useTranslation } from 'react-i18next';
import { ArrowRight, Clock, Calendar, BookOpen, Truck, Package, Shield, Wallet, Star, ShieldCheck, Search, Box, Camera, UserCheck, Tag, Flag, Shirt } from 'lucide-react';

const articles = [
  {
    slug: 'allchinabuy-spreadsheet-complete-guide',
    title: 'AllChinaBuy Spreadsheet Complete Guide',
    desc: 'A comprehensive guide to using AllChinaBuy Spreadsheet for product research, price comparison, and finding trusted sellers.',
    date: 'August 2026',
    readTime: 8,
    icon: BookOpen,
    image: 'https://readdy.ai/api/search-image?query=Organized%20product%20research%20spreadsheet%20on%20a%20laptop%20screen%20beside%20swatches%20of%20fashion%20fabric%20and%20a%20notepad%2C%20bright%20clean%20modern%20workspace%2C%20crisp%20daylight%2C%20editorial%20productivity%20photography&width=800&height=500&seq=article-guide-201&orientation=landscape&nocache=true',
  },
  {
    slug: 'shipping-guide',
    title: 'AllChinaBuy Shipping Cost Guide',
    desc: 'Compare shipping methods, costs, and delivery times to USA, UK, Germany, France, and Denmark.',
    date: 'August 2026',
    readTime: 6,
    icon: Truck,
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20stacked%20beside%20a%20world%20map%20and%20a%20tape%20measure%20on%20a%20clean%20desk%2C%20soft%20studio%20lighting%2C%20logistics%20editorial%20photography%2C%20muted%20blue%20tones&width=800&height=500&seq=article-shipping-202&orientation=landscape&nocache=true',
  },
  {
    slug: 'warehouse-guide',
    title: 'AllChinaBuy Warehouse & QC Guide',
    desc: 'Learn how warehouse storage, quality inspection, and parcel consolidation work.',
    date: 'August 2026',
    readTime: 7,
    icon: Package,
    image: 'https://readdy.ai/api/search-image?query=Bright%20modern%20warehouse%20interior%20with%20neatly%20organized%20shelves%20of%20parcels%20and%20a%20worker%20checking%20a%20clipboard%2C%20soft%20natural%20light%20through%20large%20windows%2C%20clean%20industrial%20editorial%20photography&width=800&height=500&seq=article-warehouse-203&orientation=landscape&nocache=true',
  },
  {
    slug: 'coupon-guide',
    title: 'AllChinaBuy Coupon & Discount Guide',
    desc: 'Find the latest coupon codes, discount strategies, and how to maximize savings.',
    date: 'August 2026',
    readTime: 5,
    icon: Wallet,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20discount%20coupons%20and%20a%20golden%20gift%20card%20fanned%20out%20beside%20a%20calculator%20on%20a%20warm%20walnut%20desk%2C%20soft%20lighting%2C%20savings%20concept%20editorial%20photography%2C%20rich%20warm%20tones&width=800&height=500&seq=article-coupon-204&orientation=landscape&nocache=true',
  },
  {
    slug: 'safety-guide',
    title: 'Is AllChinaBuy Safe? Complete Safety Guide',
    desc: 'Account security, payment risks, seller verification, and how to protect yourself.',
    date: 'August 2026',
    readTime: 9,
    icon: Shield,
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20a%20glowing%20shield%20icon%20over%20a%20padlock%20and%20keyboard%20on%20a%20clean%20dark%20blue%20desk%2C%20soft%20glowing%20light%2C%20tech%20editorial%20photography%2C%20calm%20secure%20mood&width=800&height=500&seq=article-safety-205&orientation=landscape&nocache=true',
  },
  {
    slug: 'beginners-guide',
    title: 'AllChinaBuy Beginners Guide 2026',
    desc: 'Step-by-step walkthrough for first-time buyers. From account setup to first order.',
    date: 'August 2026',
    readTime: 10,
    icon: BookOpen,
    image: 'https://readdy.ai/api/search-image?query=Open%20laptop%20showing%20an%20online%20shopping%20website%20with%20a%20coffee%20cup%20and%20handwritten%20notes%20on%20a%20bright%20minimal%20desk%2C%20soft%20morning%20light%2C%20cozy%20lifestyle%20editorial%20photography&width=800&height=500&seq=article-beginners-206&orientation=landscape&nocache=true',
  },
  {
    slug: 'review-2026',
    title: 'AllChinaBuy Review 2026: Pros & Cons',
    desc: 'An honest, detailed look at the platform covering shipping, warehouse, QC, and value.',
    date: 'August 2026',
    readTime: 9,
    icon: Star,
    image: 'https://readdy.ai/api/search-image?query=Hands%20writing%20a%20review%20checklist%20with%20star%20ratings%20beside%20a%20laptop%20and%20a%20shopping%20package%20on%20a%20clean%20white%20desk%2C%20bright%20airy%20lighting%2C%20editorial%20review%20photography&width=800&height=500&seq=article-review-207&orientation=landscape',
  },
  {
    slug: 'shipping-methods',
    title: 'AllChinaBuy Shipping Methods Explained',
    desc: 'Standard vs express vs air freight — a clear breakdown of every shipping option.',
    date: 'August 2026',
    readTime: 7,
    icon: Truck,
    image: 'https://readdy.ai/api/search-image?query=Several%20delivery%20trucks%20and%20air%20freight%20parcels%20illustrated%20on%20a%20soft%20teal%20background%2C%20clean%20flat%20vector%20style%2C%20logistics%20infographic%20aesthetic%2C%20bright%20modern%20composition&width=800&height=500&seq=article-methods-208&orientation=landscape',
  },
  {
    slug: 'legit',
    title: 'Is AllChinaBuy Legit? Complete Trust Guide',
    desc: 'What to verify before ordering, red flags to avoid, and how to shop confidently.',
    date: 'August 2026',
    readTime: 8,
    icon: ShieldCheck,
    image: 'https://readdy.ai/api/search-image?query=Trust%20badge%20and%20verified%20checkmark%20icons%20floating%20above%20a%20smartphone%20showing%20a%20shopping%20cart%2C%20soft%20green%20gradient%20background%2C%20clean%20tech%20editorial%20photography%2C%20reassuring%20mood&width=800&height=500&seq=article-legit-209&orientation=landscape',
  },
  {
    slug: 'product-research',
    title: 'AllChinaBuy Product Research Strategy',
    desc: 'Proven methods to find winning products and avoid low-quality listings.',
    date: 'August 2026',
    readTime: 8,
    icon: Search,
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20printed%20product%20photos%20and%20price%20comparison%20notes%20spread%20on%20a%20light%20desk%2C%20bright%20clean%20lighting%2C%20research%20editorial%20photography%2C%20focused%20analytic%20mood&width=800&height=500&seq=article-research-210&orientation=landscape',
  },
  {
    slug: 'warehouse-consolidation',
    title: 'AllChinaBuy Warehouse Consolidation Guide',
    desc: 'Combine multiple orders into one shipment to cut per-item shipping costs.',
    date: 'August 2026',
    readTime: 6,
    icon: Box,
    image: 'https://readdy.ai/api/search-image?query=Multiple%20small%20parcels%20being%20grouped%20into%20one%20large%20shipping%20box%20with%20bubble%20wrap%20on%20a%20warehouse%20table%2C%20bright%20even%20lighting%2C%20logistics%20editorial%20photography%2C%20tidy%20organized%20scene&width=800&height=500&seq=article-consolidation-211&orientation=landscape',
  },
  {
    slug: 'qc-photos',
    title: 'AllChinaBuy QC Photos: How to Read Them',
    desc: 'Learn what to look for in quality check photos before approving shipment.',
    date: 'August 2026',
    readTime: 7,
    icon: Camera,
    image: 'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20camera%20photographing%20a%20folded%20garment%20on%20a%20white%20inspection%20table%20with%20a%20measuring%20tape%2C%20bright%20studio%20lighting%2C%20quality%20control%20editorial%20photography%2C%20precise%20detail&width=800&height=500&seq=article-qc-212&orientation=landscape',
  },
  {
    slug: 'seller-verification',
    title: 'AllChinaBuy Seller Verification Guide',
    desc: 'How to find trusted sellers using ratings, reviews, and transaction history.',
    date: 'August 2026',
    readTime: 7,
    icon: UserCheck,
    image: 'https://readdy.ai/api/search-image?query=Hand%20pointing%20at%20a%20seller%20rating%20screen%20with%20five%20stars%20and%20profile%20cards%20on%20a%20tablet%2C%20clean%20bright%20desk%20setting%2C%20trust%20and%20review%20editorial%20photography%2C%20confident%20mood&width=800&height=500&seq=article-seller-213&orientation=landscape',
  },
  {
    slug: 'coupon-strategy',
    title: 'AllChinaBuy Coupon Strategy: Save More',
    desc: 'Timing, stacking, and seasonal sales tactics to maximize your discounts.',
    date: 'August 2026',
    readTime: 6,
    icon: Tag,
    image: 'https://readdy.ai/api/search-image?query=Sale%20tags%20and%20discount%20stickers%20scattered%20around%20a%20piggy%20bank%20and%20a%20calendar%20on%20a%20pastel%20desk%2C%20soft%20cheerful%20lighting%2C%20savings%20editorial%20photography%2C%20playful%20bright%20palette&width=800&height=500&seq=article-coupon-strategy-214&orientation=landscape',
  },
  {
    slug: 'shipping-usa',
    title: 'AllChinaBuy Shipping to USA: Costs & Times',
    desc: 'Everything US buyers need to know about delivery times and customs.',
    date: 'August 2026',
    readTime: 6,
    icon: Flag,
    image: 'https://readdy.ai/api/search-image?query=Package%20with%20a%20shipping%20label%20and%20a%20small%20American%20flag%20pin%20on%20a%20clean%20map%20of%20the%20USA%2C%20bright%20natural%20lighting%2C%20delivery%20editorial%20photography%2C%20patriotic%20neutral%20palette&width=800&height=500&seq=article-usa-215&orientation=landscape',
  },
  {
    slug: 'clothing-guide',
    title: 'AllChinaBuy Clothing Guide: Full Breakdown',
    desc: 'Shoes, hoodies, jackets, and more — how to buy apparel confidently.',
    date: 'August 2026',
    readTime: 8,
    icon: Shirt,
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20arranged%20wardrobe%20rack%20with%20shoes%20hoodies%20and%20jackets%20in%20coordinated%20neutral%20tones%2C%20soft%20warm%20lighting%2C%20fashion%20editorial%20photography%2C%20clean%20boutique%20aesthetic&width=800&height=500&seq=article-clothing-216&orientation=landscape',
  },
];

export default function Articles() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase mb-3 block">
              Resources
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
              {t('articles.title')}
            </h2>
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
              {t('articles.description')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.map((article, index) => (
              <article
                key={article.slug}
                className="group flex flex-col bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden hover:border-primary-300/50 transition-all duration-300 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <a href={`/article/${article.slug}`} className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} — AllChinaBuy Spreadsheet Guide`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </a>

                <div className="flex flex-col flex-1 p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="flex items-center gap-1 text-xs text-foreground-500">
                      <Calendar className="w-3.5 h-3.5" />
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-500">
                      <Clock className="w-3.5 h-3.5" />
                      {article.readTime} min read
                    </span>
                  </div>

                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                    {article.title}
                  </h3>

                  <p className="text-foreground-600 text-sm leading-relaxed mb-4 flex-1">
                    {article.desc}
                  </p>

                  <a
                    href={`/article/${article.slug}`}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors group/link"
                  >
                    {t('articles.readMore')}
                    <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}